/** GG gateway HTTP API path segments (relative to gateway base URL). */
export const GATEWAY_ROUTE_LIBRARIES = 'libraries'
export const GATEWAY_ROUTE_GUID = 'guid'
export const GATEWAY_ROUTE_REGISTRY = 'registry'
export const GATEWAY_ROUTE_PROJECT = 'project'
export const GATEWAY_ROUTE_GSMU_ENDPOINT = 'gsmuendpoint'
export const GATEWAY_ROUTE_WEBSOCKET_PORT = 'websocketport'
export const GATEWAY_ROUTE_MCP_PORT = 'mcpport'

/** WebSocket channel path appended to the gateway host in connection URLs. */
export const GATEWAY_WEBSOCKET_CHANNEL_PATH = 'ws'
